var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-bubble-chart-wrapper"},[_c('BubbleChart',{staticClass:"bubble-chart",attrs:{"chart-data":_vm.processedChartData,"options":_vm.options}}),_c('span',{staticClass:"footnote"},[_vm._v(_vm._s(_vm.$t('withoutTenantSideNote')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }